import { defineFcm } from '../shared/factory';

export const FCM_LCM_STARTER_PETITION_SHARE_MILESTONE_ENABLED = defineFcm(
	'lcm_starter_petition_share_milestone_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description: 'Enables sending starter petition share milestone messages to Iterable.',
		import: false,
	});
